import { createReducer, on } from '@ngrx/store';
import * as actions from './current.actions';
import {
  CurrentSubscriptionState,
  initialCurrentSubscriptionState,
} from './current.state';

export const currentSubscriptionReducer = createReducer(
  initialCurrentSubscriptionState,
  on(
    actions.loadCurrentSubscriptionSuccess,
    (_state, { subscription }): CurrentSubscriptionState => ({
      ...initialCurrentSubscriptionState,
      loadStatus: 'success',
      subscription,
    })
  ),
  on(
    actions.loadCurrentSubscriptionError,
    (_state, { error }): CurrentSubscriptionState => ({
      ...initialCurrentSubscriptionState,
      loadStatus: 'error',
      error,
    })
  )
);
